import React from 'react'
import SigninUi from '../Ui/SigninUi'
const Signin =()=>{

    return <SigninUi/>
}

export default Signin